<div
  *ngIf="
    (newItem?.splitByAvailability === true ||
    newItem?.stockAvailability === false ||
    showCheckAvalabilityAction) && 
    (newItem?.quoteCartEntryType == null 
    || newItem?.quoteCartEntryType == '') || newItem?.minOrderQuantity > newItem?.quantity
  "
  class="availibility-error"
>
  <i class="material-icons">report</i><strong> {{ "savedCart.error" | cxTranslate }} </strong>
  <span class="error-text">{{ msgText }}</span>
</div>
<div
  [ngClass]="{
    'cx-compact row cart-entry m-0': compact,
    'row cart-entry m-0': !compact,
    'last-cart-entry': entryNum == totalEntries
  }"
>
  <!-- <i
    *ngIf="
      newItem?.splitByAvailability === true ||
      newItem?.stockAvailability === false
    "
    matTooltipClass="vs-tooltip capitalize"
    matTooltip="{{ msgText }}"
    class="material-icons item-warning"
    >error</i
  > -->

  <div class="col-5 col-md-5 row">
    <div class="col-1 p-0">
      <div *ngIf="!item.quoteCartEntryType" class="vs-checkbox float-left select-product-check">
        <input
          [id]="'cart-entry-' + entryNum"
          type="checkbox"
          value="true"
          [checked]="checkAll"
          [name]="'cart-entry-' + entryNum"
          (click)="checkEntry($event)"
        />
        <label [for]="'cart-entry-' + entryNum" class="cart-item-check"></label>
      </div>
      <span class="cart-entry-text-bold cart-entry-number">{{ entryNum }}</span>
    </div>

    <!-- Item Image -->
    <div class="col-3 cx-image-container">
      <a
        [routerLink]="{ cxRoute: 'product', params: item.product } | cxUrl"
        (click)="viewItem(item)"
        tabindex="-1"
      >
        <cx-media [container]="item.product.images?.PRIMARY"></cx-media>
      </a>
    </div>

    <!-- Item Information -->
    <div class="cx-info col-8">
      <div class="cx-info-container">
        <!-- Item Description -->
        <div class="w-100">
          <div *ngIf="item.product.code" class="cx-code entry-id">
            <label>{{ "savedCart.partModelNumber" | cxTranslate }}</label>
            <a
              class="cx-link cart-entry-text-bold"
              [routerLink]="
                { cxRoute: 'product', params: item.product } | cxUrl
              "
              (click)="viewItem(item)"
              >{{ item.product.code }}
            </a>
            <!-- <span class="cart-entry-text-bold">{{ item.product.code }}</span> -->
          </div>
          <div *ngIf="item.product.name" class="cx-name entry-name">
            <label>{{ "savedCart.partDescription" | cxTranslate }}</label>
            <!-- <a class="cx-link cart-entry-text-bold" [routerLink]="{ cxRoute: 'product', params: item.product } | cxUrl"
              (click)="viewItem()">{{ item.product.name }}</a> -->
            <span class="cart-entry-text-bold">{{ item.product.name }}</span>
          </div>
        </div>

        <!-- Total -->
        <!-- <ng-container *ngIf="options.isSaveForLater; else total">
          <div class="cx-total" [ngClass]="compact ? '' : ' col-md-3 col-lg-3 col-xl-2'">
            <div class="cx-label" [ngClass]="compact ? '' : ' d-block d-md-none d-lg-none d-xl-none'">
              {{ 'saveForLaterItems.stock' | cxTranslate }}
            </div>
            <div *ngIf="item.product?.stock?.stockLevel >= 0; else forceInstock" class="cx-value">
              {{ item.product.stock.stockLevel }}
            </div>
            <ng-template #forceInstock>
              <div class="cx-value">
                {{ 'saveForLaterItems.forceInStock' | cxTranslate }}
              </div>
            </ng-template>
          </div>
        </ng-container> -->
      </div>

      <!-- Material Number Input -->
      <div class="matnum-input-container">
        <label>{{ 'savedCart.materialNumber' | cxTranslate }}</label>
        <input
          class="matnum-input"
          id="matnum"
          type="text"
          minlength="3"
          maxlength="25"
          [(ngModel)]="newItem.customerMaterialNumber"
          [ngClass]="item.quoteCartEntryType ? 'disabled' : ''"
          placeholder="{{
            'savedCart.materialNumberPlaceholder' | cxTranslate
          }}"
        />
        <a
          class="save-material-num"
          (mousedown)="onSaveMaterialNumMouseDown($event)"
          (click)="materialInputChanges()"
          *ngIf="!savingMaterialNum"
          [ngClass]="item.quoteCartEntryType ? 'disabled' : ''"
        >
          <i class="material-icons ml-0">save</i>
        </a>

        <span class="save-material-num" *ngIf="savingMaterialNum">{{
          'savedCart.saving' | cxTranslate
        }}</span>
      </div>
      
      <div class="comments-action-holder">
        <a
          class="action-links"
          *ngIf="!showCommentsInput"
          (click)="showCommentsInput = true"
          >+ {{ "savedCart.additionalComments" | cxTranslate }}</a
        >
        <div *ngIf="showCommentsInput" class="add-comments-controls">
          <a class="action-links" (click)="showCommentsInput = false"
            >- {{ "savedCart.additionalComments" | cxTranslate }}</a
          >
          <div class="vs-text-area">
            <textarea
              class="item-comments"
              [(ngModel)]="newItem.comment"
              (input)="commentError = false"
              maxlength="255"
              [class.error]="
                (commentError && newItem.comment?.length <= 0) ||
                (showCommentsNotSavedErr && newItem.comment?.length > 0)
              "
              [ngClass]="item.quoteCartEntryType ? 'disabled' : ''"
              (blur)="onCommentsInputBlur($event)"
            ></textarea>
            <label
              *ngIf="commentError && newItem.comment?.length <= 0"
              class="error"
              >{{ "savedCart.pleaseAddComments" | cxTranslate }}</label
            >
            <label
              *ngIf="showCommentsNotSavedErr && newItem.comment?.length > 0"
              class="error"
              >{{ "savedCart.commentsNotSaved" | cxTranslate }}
              </label>
            <div class="comments-action-holder mt-1 pl-0">
              <a
                #saveComments
                *ngIf="!savingComments"
                class="comment-save"
                (mousedown)="onSaveCommentsMouseDown($event)"
                (click)="saveComments()"
              >
                <i class="material-icons ml-0">save</i>
              </a>
              <span class="char-limit" *ngIf="savingComments">{{ "savedCart.saving" | cxTranslate }}</span>
              <label class="char-limit"
                >{{ "savedCart.charactersLeft" | cxTranslate }} {{ 255 - newItem.comment?.length }}</label
              >
            </div>
          </div>
        </div>
      </div>
      <!-- Availability -->
      <!-- <div *ngIf="isProductOutOfStock(item.product)" class="cx-availability col-12">
        {{ 'productSummary.outOfStock' | cxTranslate }}
      </div> -->
      <!-- Promotion -->

      <!-- <ng-container *ngIf="appliedProductPromotions$ | async as appliedProductPromotions">
        <cx-promotions [promotions]="appliedProductPromotions"></cx-promotions>
      </ng-container> -->

      <!-- Actions -->
      <!-- <div *ngIf="(!readonly || options.isSaveForLater) && item.updateable" class="cx-actions col-12">
        <ng-container *ngIf="!isProductOutOfStock(item.product)">
          <ng-container *ngTemplateOutlet="
            options.optionalBtn;
            context: {
              $implicit: { loading: quantityControl.disabled, item: item }
            }
          "></ng-container>
        </ng-container>

        <div class="col-md-3 cx-remove-btn">
          <button class="link cx-action-link" [disabled]="quantityControl.disabled" (click)="removeItem()">
            {{ 'common.remove' | cxTranslate }}
          </button>
        </div>
      </div> -->
    </div>
  </div>

  <div class="col-2 p-0">
    <!-- Item Quantity -->
    <div>
      <div
        class="cart-entry-text-bold qty-text"
        placement="left"
        title="{{ 'savedCart.qtyTooltip' | cxTranslate }}"
      >
        {{ "savedCart.qty" | cxTranslate }}
      </div>
      <div
        class="float-left"
        [ngClass]="item.quoteCartEntryType ? 'disabled' : ''"
      >
        <vs-item-counter
          [control]="quantity"
          [readonly]="!item.updateable || readonly || options.isSaveForLater"
          [min]="1"
          [max]="9999"
          [disabled]="showAvailabilityLoader"
          [ngClass]="item.quoteCartEntryType ? 'disabled' : ''"
        >
        </vs-item-counter>
        <span
          class="lot-size-text"
          *ngIf="
            item.salesConversion &&
            (item.salesUnit.toLowerCase() == 'pk' ||
              item.salesUnit.toLowerCase() == 'pack')
          "
          >1 {{ "savedCart.pack" | cxTranslate }} = {{ item.salesConversion }} {{ "savedCart.units" | cxTranslate }}</span
        >
        <!-- <vs-item-counter class="float-left" [control]="quantity" [max]="9999"></vs-item-counter> -->
      </div>
      <div placement="right" class="uom-text">
        {{ item.salesUnit }}
      </div>
    </div>
  </div>

  <div class="col-2 p-0">
    <!-- List Price -->
    <div *ngIf="item.basePrice" class="list-price">
      <label> {{ "savedCart.listPrice" | cxTranslate }} </label>
      <div *ngIf="item.basePrice" class="cart-entry-text-bold">
        <span
          >{{ item.basePrice?.currencyIso }}
          {{ item.basePrice?.formattedValue }}</span
        >
      </div>
    </div>
    <!-- Item Price -->
    <div *ngIf="item.basePrice" class="base-price">
      <label>
        {{ "savedCart.yourPrice" | cxTranslate }}
        <ng-container *ngIf="item.basePrice?.value">
        <a
        *ngIf = "item.expressAdder && item.expressAdder?.value > -1" class='material-icons' matTooltipClass="vs-tooltip" matTooltip='{{ "savedCart.expressDeliveryTooltipTxt" | cxTranslate}}' matTooltipPosition="above"
          (click)="this.breakUp = !this.breakUp"
          class="cart-entry-text-bold breakup-link link-color-eda"
          #viewBreakupLink
        >
        {{ "savedCart.viewBreakup" | cxTranslate }}
          <i *ngIf="!breakUp" class="material-icons">keyboard_arrow_down</i>
          <i *ngIf="breakUp" class="material-icons">keyboard_arrow_right</i>
        </a>
        <a
        *ngIf="!(item.expressAdder && item.expressAdder?.value > -1)"
        (click)="this.breakUp = !this.breakUp"
        class="cart-entry-text-bold breakup-link link-color "
        #viewBreakupLink
        >
        {{ "savedCart.viewBreakup" | cxTranslate }}
          <i *ngIf="!breakUp" class="material-icons">keyboard_arrow_down</i>
          <i *ngIf="breakUp" class="material-icons">keyboard_arrow_right</i>
        </a>
        </ng-container> 

        <div
          class="breakup-dropdown product-data-text"
          *ngIf="breakUp"
          (clickOutside)="closeMenu($event)"
          #breakupContent
        >
          <div class="row list-price-row m-0">
            <span class="price-menu-heading bold">{{ "savedCart.listPrice" | cxTranslate }}</span>
            <span class="price-menu-content bold"
              >{{ item.basePrice?.currencyIso }}
              {{ item.basePrice?.formattedValue }}</span
            >
          </div>
          <div class="mb-4" *ngIf="item.discountDetails?.length > 0">
            <div
              class="row discounts"
              *ngFor="let discounts of item.discountDetails"
            >
              <span class="price-menu-heading col-6 p-0">{{
                getDiscountName(discounts.code)
              }}</span>
              <span class="price-menu-content col-2 p-0"
                >{{ discounts.appliedValue }}%</span
              >
              <span class="price-menu-content col-4 p-0 text-right"
                >{{ discounts.currency }} -{{ discounts.formattedValue }}</span
              >
            </div>
          </div>
		  <div
          class="row discounts"
          *ngIf="item.afterMarket && item.afterMarket?.value > -1">
          <span class="price-menu-heading col-6 p-0"
            >{{ "savedCart.afterMarketFactor" | cxTranslate }}</span>
          <span class="price-menu-content col-2 p-0"
            >{{ item?.afterMarketPremium }}%</span>
          <span class="price-menu-content col-4 p-0 text-right"
            >{{ item.afterMarket?.currencyIso }}
            {{ item.afterMarket?.formattedValue }}</span>
          </div>
          <div
            class="row discounts"
            *ngIf="item.expressAdder && item.expressAdder?.value > -1"
          >
            <span class="price-menu-heading col-6 p-0"
              >{{ "savedCart.expressDeliveryAdder" | cxTranslate }}</span
            >
            <span class="price-menu-content col-2 p-0"
              >{{ item?.expressAdderPercent }}%</span
            >
            <span class="price-menu-content col-4 p-0 text-right"
              >{{ item.expressAdder?.currencyIso }}
              {{ item.expressAdder?.formattedValue }}</span
            >
          </div>
          <!--Tariff surcharge div start-->
          <div
            class="row discounts"
            *ngIf="item.tariffCharges && item.tariffCharges?.value > -1"
          >
            <span class="price-menu-heading col-6 p-0"
              >{{ "savedCart.tariffSurcharge" | cxTranslate }}</span
            >
            <span class="price-menu-content col-2 p-0"
              >{{ item?.tariffChargesPercent }}%</span
            >
            <span class="price-menu-content col-4 p-0 text-right"
              >{{ item.tariffCharges?.currencyIso }}
              {{ item.tariffCharges?.formattedValue }}</span
            >
          </div>
          <!--Tariff surcharge div end-->
          <div
            class="row total-discounts"
            *ngIf="item.discountDetails?.length > 0"
          >
            <span class="price-menu-heading bold">{{ "savedCart.totalAdjustment" | cxTranslate }}</span>
            <span class="price-menu-content bold"
              >{{ item.basePrice?.currencyIso }}-
              <!-- {{ getTotalDiscounts(item.basePrice, item.netPrice) }} -->
              {{(item.basePrice.value - item.netPrice.value)| currency: item.basePrice?.currencyIso:"symbol-narrow"}}
              </span>
          </div>
          <div class="row net-price">
            <span class="price-menu-heading bold">{{ "savedCart.netPrice" | cxTranslate }}</span>
            <span class="price-menu-content bold"
              >{{ item.netPrice?.currencyIso }}
              {{ item.netPrice?.formattedValue }}</span
            >
          </div>
        </div>
      </label>
      <div *ngIf="item.basePrice" class="cart-entry-text-bold">
        <span
          >{{ item.netPrice?.currencyIso }}
          {{ item.netPrice?.formattedValue }}</span
        >
      </div>
    </div>
    <!-- Extended Price -->
    <div *ngIf="item.totalPrice" class="extended-price">
      <label> {{ "savedCart.extendedPrice" | cxTranslate }} </label>
      <div *ngIf="item.totalPrice" class="cart-entry-text-bold">
        <span
          >{{ item.totalPrice?.currencyIso }}
          {{ item.totalPrice?.formattedValue }}</span
        >
      </div>
    </div>
  </div>

  <div class="col-3 p-0">
    <!-- Customer Requested Ship Date -->
    <div class="requested-date-holder">
      <label> {{ "savedCart.requestedShipDate" | cxTranslate }}</label>
      <vs-date-picker
        class="mb-1"
        (selectedDate)="onDateChange($event, 'crd')"
        [defaultDate]="item?.customerRequestedDate"
        [min]="minDate"
        [disabled]="showAvailabilityLoader"
        [filterWeekend]="filterWeekend"
        [activateSelectedDay]="cart?.isConsolidatedShipment"
        [selectedDay]="selectedDay"
        [selectedEntity]="selectedLegalEntityId"
        [dateInputLabel]="'crd'"
        [ngClass]="item.quoteCartEntryType ? 'disabled' : ''"
      >
      </vs-date-picker>
      <!-- <label *ngIf="showReqShipError || consolidatedShipError" class="error req-ship-error">
        {{ "savedCart.adjustReqShipDate" | cxTranslate }}
        {{ cart.consolidatedDay | titlecase }} 
        {{ "savedCart.consolidatedShipDay" | cxTranslate }}
      </label>
      <label
        *ngIf="showDeliGrpError && deliGrpErrorType == '103'"
        class="error req-ship-error"
      >
      {{ "savedCart.requestedDateShouldSame" | cxTranslate }}
      </label> -->
    </div>

    <!-- Promised Ship Date -->
    <div class="requested-date-holder">
      <label> {{ "savedCart.promisedShipDate" | cxTranslate }}</label>
      <vs-date-picker
        class="mb-1"
        (selectedDate)="onDateChange($event, 'psd')"
        [defaultDate]="item?.assignedShipDate"
        [min]="minDate"
        [disabled]="showAvailabilityLoader"
        [filterWeekend]="filterWeekend"
        [activateSelectedDay]="cart?.isConsolidatedShipment"
        [selectedDay]="selectedDay"
        [selectedEntity]="selectedLegalEntityId"
        [showError]="
          showReqShipError|| consolidatedShipError || (showDeliGrpError && deliGrpErrorType == '103')
        "
        [ngClass]="item.quoteCartEntryType ? 'disabled' : ''"
      >
      </vs-date-picker>
      <label *ngIf="showReqShipError || consolidatedShipError" class="error req-ship-error">
        {{ "savedCart.adjustPromShipDate" | cxTranslate }}
        {{ cart.consolidatedDay | titlecase }} 
        {{ "savedCart.consolidatedShipDay" | cxTranslate }}
      </label>
      <label
        *ngIf="showDeliGrpError && deliGrpErrorType == '103'"
        class="error req-ship-error"
      >
      {{ "savedCart.promisedDateShouldSame" | cxTranslate }}
      </label>
    </div>

    <!-- Available At -->
    <div
      *ngIf="productOpen && item.plantAvailableAt?.length"
      class="available-at-holder"
    >
      <label> {{ "savedCart.shippedFrom" | cxTranslate }} </label>
      <div class="available-at-dropdown">
        <ng-select
          (change)="onLegalEntitySelect($event)"
          class="mb-1"
          [(ngModel)]="selectedLegalEntity"
          [class.disabled]="showAvailabilityLoader"
          [searchable]="false"
          [clearable]="false"
          [disabled]="showAvailabilityLoader"
          [class.error]="showDeliGrpError && deliGrpErrorType == '104'"
          [ngClass]="item.quoteCartEntryType ? 'disabled' : ''"
        >
          <!-- <option disabled selected hidden>Select</option> -->
          <ng-option
            *ngFor="let entity of shippedFrmOptions; let i = index"
            [value]="entity"
          >
            {{ entity.name }} ({{
              entity.stockAvailable.toString() | number: "1.0-0"
            }})
          </ng-option>
        </ng-select>
        <label
          *ngIf="showDeliGrpError && deliGrpErrorType == '104'"
          class="error req-ship-error"
        >
        {{ "savedCart.diffShipLocations" | cxTranslate }}
        </label>
        <label *ngIf="showDiffPlantWarning" class="different-plant-warning">
          <i class="material-icons mr-2">info</i>
          <span>{{ "savedCart.twoWeeksShippingMsg" | cxTranslate }}</span>
        </label>
      </div>
    </div>

    <!-- Availability Action -->
    <div
      *ngIf="productOpen && showCheckAvalabilityAction"
      class="availability-action-holder"
    >
      <button
        class="vs-tertiary-btn"
        (click)="checkAvailability()"
        [disabled]="showAvailabilityLoader"
      >
        <span *ngIf="!showAvailabilityLoader">{{ "savedCart.checkAvailability" | cxTranslate }}</span>
        <div
          *ngIf="showAvailabilityLoader"
          class="availability-spinner cx-spinner"
        >
          <cx-spinner></cx-spinner>
        </div>
      </button>
    </div>

    <!-- Availability Info -->
    <div
      *ngIf="productOpen && !showCheckAvalabilityAction"
      class="availability-info-holder"
    >
      <!-- <label>{{ "savedCart.availabilityInformation" | cxTranslate }}  </label> -->
      <div class="availability-info">
        <!-- <label *ngIf="item.stockAvailability" class="cart-entry-text-bold">
          <span class="mr-2">{{ "savedCart.quantityCamelCase" | cxTranslate }}  - </span>
          <span>{{ getAvailableQuantity(item.quantity) }} {{ "savedCart.available" | cxTranslate }}</span>
        </label> -->
        <label *ngIf="!item.stockAvailability" class="cart-entry-text-bold">
          {{ "savedCart.noStockAvailable" | cxTranslate }}
        </label>
        <label *ngIf="item.availabilityDetail" class="cart-entry-text-bold">
          <span
            *ngFor="let avail of item.availabilityDetail"
            class="d-block mt-2"
          >
            <ng-container *ngIf="getEarliestPossibleDate(avail)">
              {{ "savedCart.earlyShipDate" | cxTranslate }}
              {{ avail.committedQuantity | number }} is
              {{ avail.committedDate | date }}
              <span *ngIf="!item.stockAvailability"
                >. {{ "savedCart.getQuoteIfneeded" | cxTranslate }}
                {{ item?.customerRequestedDate | date }}</span
              >
            </ng-container>
          </span>
        </label>
      </div>
    </div>

    <!-- View Inventory -->
    <div
      *ngIf="productOpen && otherInventoryLocations?.length">
        <a class="link"
          (click)="viewInventory()"
        >{{ "savedCart.viewInventoryLocations" | cxTranslate }}</a>
    </div>
    <div
      *ngIf="productOpen && checkAvailabilityError"
      class="availability-info-holder"
    >
      <label class="cart-entry-text-bold error">
        {{ "savedCart.errFetchingAvailability" | cxTranslate }}
      </label>
    </div>

    <div
      class="delivery-groups-holder"
      *ngIf="newItem.deliveryGroupNumber && isShipmentPartial"
    >
      <div class="vs-text-field">
        <label> {{ "savedCart.createDeliveryGroups" | cxTranslate }}</label>
        <input
          type="text"
          [(ngModel)]="deliveryGroupNumber"
          (blur)="onDeliveryGroupInputBlur()"
          class="mb-1"
          [class.error]="showDeliGrpError"
          (input)="showDeliGrpError = false"
          [disabled]="deliveryGroupLoader"
        />
        <div
          *ngIf="deliveryGroupLoader"
          class="delivery-group-spinner cx-spinner float-right"
        >
          <cx-spinner></cx-spinner>
        </div>
        <label
          *ngIf="showDeliGrpError && deliGrpErrorType == '103'"
          class="error req-ship-error"
          > {{ "savedCart.requestedDateMsg" | cxTranslate }} 
          </label>
        <label
          *ngIf="showDeliGrpError && deliGrpErrorType == '104'"
          class="error req-ship-error"
          > {{ "savedCart.diffShipLocations" | cxTranslate }}
        </label>
        <label
          *ngIf="showDeliGrpError && deliGrpErrorType == '100'"
          class="error req-ship-error"
          > {{ "savedCart.pleaseEnterDeliveryNum" | cxTranslate }}</label
        >
      </div>
    </div>

    <div
      class="action-holder float-right"
      [ngClass]="!productOpen ? 'action-top-collapse' : 'action-top-expand'"
    >
      <a
        class="action-links mr-3"
        *ngIf="item.splitByAvailability"
        (click)="splitEntry()"
        > {{ "savedCart.splitByAvailability" | cxTranslate }}</a
      >

      <a
        class="action-links mr-3"
        (click)="splitItemByQty()"
        [ngClass]="item.quantity <= 1 ? 'disabled' : ''"
        > {{ "savedCart.splitByQuantity" | cxTranslate }} </a
      >

      <a
        class="action-links"
        (click)="openDeleteDialog()"
        [ngClass]="item.quoteCartEntryType ? 'disabled' : ''"
        > {{ "savedCart.delete" | cxTranslate }}</a
      >
    </div>
  </div>

  <div class="toggle-arrow">
    <i
      *ngIf="productOpen"
      (click)="toggleProduct()"
      class="material-icons right"
    >
      keyboard_arrow_up
    </i>
    <i
      *ngIf="!productOpen"
      (click)="toggleProduct()"
      class="material-icons right"
    >
      keyboard_arrow_down
    </i>
  </div>
</div>

<ng-template #total>
  <div
    *ngIf="item.totalPrice"
    class="cx-total"
    [ngClass]="compact ? '' : ' col-md-3 col-xl-2'"
  >
    <div
      class="cx-label"
      [ngClass]="compact ? '' : ' d-block d-md-none d-lg-none d-xl-none'"
    >
      {{ "cartItems.total" | cxTranslate }}
    </div>
    <div class="cx-value">{{ item.totalPrice.formattedValue }}</div>
  </div>
</ng-template>
